import { useEffect, useRef } from 'react';

import { useStores } from 'mobx/hooks/useStores';

import { TicketClinicianMessageStatusType } from './TicketClinicianMessage/TicketClinicianMessage.types';
import { TicketMessage, TicketMessageType } from './TicketMessages.types';

export const usePollingWhenClinicianTicketMessageIsPending = (
  ticketMessages: TicketMessage[],
  fetchTicketMessages: () => Promise<TicketMessage[]>
) => {
  const { settingsStore } = useStores();
  const { min, max, multiplier } = settingsStore.institutionSettings.twoWayMessagingPollingBackoff;

  const backoff = useRef({
    delay: min,
    isPolling: false
  });

  useEffect(
    function initializePolling() {
      let timeout: NodeJS.Timeout;

      const lastMessage = ticketMessages[ticketMessages.length - 1];

      // start polling
      if (
        lastMessage &&
        lastMessage.senderType === TicketMessageType.Clinician &&
        (lastMessage.status === TicketClinicianMessageStatusType.Pending ||
          lastMessage.status === TicketClinicianMessageStatusType.Processing)
      ) {
        backoff.current.isPolling = true;
        timeout = setTimeout(() => {
          // set backoff
          backoff.current.delay = Math.min(backoff.current.delay * multiplier, max);

          // poll messages
          fetchTicketMessages();
        }, backoff.current.delay);
      }

      // polling ended
      else if (backoff.current.isPolling) {
        backoff.current.isPolling = false;
        backoff.current.delay = min;
      }

      return () => {
        // polling will stop and reset on un-mount
        // when an element is not in view or messages are not open
        clearTimeout(timeout);
      };
    },
    [ticketMessages, fetchTicketMessages, min, max, multiplier]
  );
};
